module.exports = __webpack_public_path__ + "img/sinPerfil.f6ccac33.png";